import { ContentfulAsset, ContentfulSideBySide } from '@jbhi-fi/apis/src/contentful/types';
import { SideBySideProps } from '../../SideBySide/SideBySide';
import { AssetTransformer } from './AssetTransformer';
import { ButtonTransformer } from './ButtonTransformer';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

const isAssetVideo = (asset: ContentfulAsset) => asset.fields?.file.contentType === 'video/mp4';

export abstract class SideBySideTransformer {
  static toSideBySideProps = (entry: ContentfulSideBySide): SideBySideProps => {
    return {
      heading: entry.fields?.heading,
      youTubeProps: entry.fields?.youTube?.fields ? { videoUrl: entry.fields.youTube.fields.url } : undefined,
      imageProps:
        entry.fields?.imageOrVideo && !isAssetVideo(entry.fields.imageOrVideo)
          ? AssetTransformer.toContentfulImageProps(entry.fields.imageOrVideo)
          : undefined,
      videoProps:
        entry.fields?.imageOrVideo && isAssetVideo(entry.fields.imageOrVideo)
          ? AssetTransformer.toVideoPlayerProps(entry.fields.imageOrVideo)
          : undefined,
      tagProps: entry.fields?.tag
        ? {
            label: entry.fields.tag,
            palette: { background: palette.primary.main },
          }
        : undefined,
      isReversed: entry.fields?.assetPosition === 'Right',
      ctaButtonProps: entry.fields?.ctaLink ? ButtonTransformer.toGoToLinkProps(entry.fields.ctaLink) : undefined,
      body: entry.fields?.body,
    };
  };
}
